import { useEffect, useRef } from 'react';

type IHtmlAudioPlayerProps = {
  mp3File: string;
};

const HtmlAudioPlayer = ({ mp3File }: IHtmlAudioPlayerProps) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.load(); // Update player every time mp3File changes
    }
  }, [mp3File]);

  return (
    <audio ref={audioRef} controls>
      <source src={mp3File} type="audio/mp3" />
      Your browser does not support the audio element
    </audio>
  );
};

export default HtmlAudioPlayer;
